import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
// import AddIcon from '@material-ui/icons/Add'
import { FormControlLabel, Grid, Radio, RadioGroup } from '@material-ui/core'
import { getActivitiesByForm } from '../../../../../../services/Elegibilidad/get'

// import { useFormElegibilidad } from '../../../../../../context/ElegibilidadContext'
import { useEligibility } from '../../../../../../context/EligibilityContext'

const Table391 = ({ idElegibilityForm }) => {
  const [state] = useEligibility()

  const [tableData, setTableData] = useState([])

  const getDataTable = async () => {
    try {
      const response = await getActivitiesByForm(idElegibilityForm)
      if (response.Code === 200) {
        setTableData(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])
  const columns = [
    // {
    //   title: 'Código',
    //   field: 'IdProductiveActivityPlanning',
    //   sorting: true,
    //   filtering: false,
    //   cellStyle: { c },
    //   // headerStyle: { color: '#fff' },
    // },
    {
      title: 'Actividad climática',
      field: 'ActivityDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'onAdd',
    },

    {
      title: 'Frecuencia',
      field: 'opc',
      sorting: false,
      filtering: false,
      // editComponent: (rowData) => (
      //   <RadioGroup
      //     aria-labelledby="demo-radio-buttons-group-label"
      //     name="radio-buttons-group"
      //     row
      //     onChange={(e) => (optionValue = e.target.value)}
      //   >
      //     <FormControlLabel value="NU" control={<Radio />} label="Nunca" />
      //     <FormControlLabel
      //       value="NM"
      //       control={<Radio />}
      //       label="Normalmente"
      //     />
      //     <FormControlLabel value="AM" control={<Radio />} label="A Menudo" />
      //   </RadioGroup>
      // ),

      type: 'boolean',

      render: (rowData) => (
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={rowData.IdOption}
          name="radio-buttons-group"
          row
        >
          <FormControlLabel
            value="NU"
            control={<Radio />}
            disabled
            label="Nunca"
          />
          <FormControlLabel
            value="NM"
            control={<Radio />}
            label="Normalmente"
            disabled
          />
          <FormControlLabel
            value="AM"
            control={<Radio />}
            label="A Menudo"
            disabled
          />
        </RadioGroup>
      ),
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            // editable={{
            //   isDeleteHidden: (rowData) => rowData.IdActivity !== 1,
            //   onRowAdd: addOther
            //     ? (newRow) =>
            //         new Promise((resolve, reject) => {
            //           setTimeout(() => {
            //             console.log('nuevo', optionValue)
            //             if (
            //               newRow.ActivityDetail === undefined ||
            //               optionValue === null
            //             ) {
            //               alertValidationFields()
            //             } else {
            //               handleGuardar(newRow)
            //             }
            //             resolve()
            //           }, 500)
            //         })
            //     : null,
            //   onRowUpdate: (newData, oldData, rowData) =>
            //     new Promise((resolve, reject) => {
            //       handleActualizar(oldData)
            //       setTimeout(() => resolve(), 500)
            //     }),
            //   onRowDelete: (oldData) =>
            //     new Promise((resolve, reject) => {
            //       handleDelete(oldData.IdProductiveActivityPlanning)
            //       setTimeout(() => resolve(), 500)
            //     }),
            // }}
            // onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',
              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              // toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              // grouping: true,
              columnsButton: false,
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            // icons={{
            //   Add: () => (
            //     <Button
            //       variant="contained"
            //       color="success"
            //       style={{ backgroundColor: '#27C27D', color: '#FFFFFF' }}
            //       startIcon={<AddIcon style={{ color: 'white' }} />}
            //     >
            //       Agregar otra actividad
            //     </Button>
            //   ),
            //   Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
            //   Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            // }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table391)
